import { useParam } from "@blitzjs/next"
import { useMutation } from "@blitzjs/rpc"
import { AnalyticsEvent } from "@superwall-me/schema"
import { z } from "zod"
import capture from "../mutations/capture"
import { TAnalyticsEvent } from "@superwall/legacy-api-utils"

export type TGroupOptionalTAnalyticsEvent = Omit<TAnalyticsEvent, "group"> & {
  group?: TAnalyticsEvent["group"]
}

const useAnalytics = () => {
  const applicationId = useParam("applicationId", "number")!

  const [captureMutation] = useMutation(capture)

  return async (_event: TGroupOptionalTAnalyticsEvent | TGroupOptionalTAnalyticsEvent[]) => {
    const events: z.infer<typeof AnalyticsEvent>[] = (
      Array.isArray(_event) ? _event : [_event]
    ).map(
      (event) =>
        ({
          ...event,
          group: event.group ? event.group : { kind: "application", object: { applicationId } },
        } as z.infer<typeof AnalyticsEvent>)
    )

    // Go look for all the utm_ parameters
    let utmParameters: Record<string, string> = {}
    if (typeof window !== "undefined") {
      // Loop through all search params and look for utm_ parameters
      new URLSearchParams(window.location.search).forEach((value, key) => {
        if (key.startsWith("utm_") || key == "ref") {
          utmParameters[key] = value
        }
      })
    }

    await captureMutation({
      events,
      properties: Object.entries(utmParameters).length > 0 ? { ...utmParameters } : {},
    })
  }
}

export default useAnalytics
